var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('BaoCaoGeneric',{attrs:{"report-type":_vm.reportType,"reports-data":_vm.formattedReports,"header-mapper":_vm.headerMapper,"format-mapper":_vm.formatMapper,"choices-mapper":_vm.choicesMapper}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }